export default __webpack_public_path__ + "static/media/header-visu7.7b3a69a1.jpg";